import {Box, Button, Modal, Stack, Typography} from "@mui/material";
import MultipleSelect from "components/MultipleSelect";
import React, {useEffect, useState} from "react";
import {useQuestionListContext} from "pages/Faq/context/questionContext";
import ArchiveCheckbox from "components/Checkbox";

interface FilterModalProps {
  open: boolean;
  onClose: () => void;
}

const FilterModal = ({open, onClose}: FilterModalProps) => {

  const {tagList, setSelectedTags, selectedTags, setArchivedChecked} = useQuestionListContext();
  const [tags, setTags] = useState<string[]>([]);
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (selectedTags?.length === 0) setTags([])
  }, [selectedTags?.length])

  const handleSetFilter = () => {
    setSelectedTags(tags);
    setArchivedChecked(checked)
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose} >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'white',
        width: '80%',
        px: 3.5,
        py: 4
      }}>
        <Stack spacing={2}>
          <Stack direction={'row'} spacing={2}>
            <Typography variant={'h5'}>
              Фильтр
            </Typography>
            <Button
              onClick={() => {
                setSelectedTags([]);
                setTags([]);
                setArchivedChecked(false)
                setChecked(false)
              }}
              sx={{
              color: 'grey.200',
              fontFamily: 'Pragmatica, Arial, sans-serif',
              fontSize: 12,
              fontStyle: 'normal',
              fontWeight: 400,
              borderBottom: '0.2px solid',
              borderColor: 'grey.200',
              p: 0,
              borderRadius: 0
            }}>
              Сбросить все
            </Button>
          </Stack>
          <ArchiveCheckbox label="Показать архивные вопросы" checked={checked} setIsChecked={setChecked}/>
          <MultipleSelect options={tagList || []} label={'Теги'} selectedTags={tags} setSelectedTags={setTags}/>
          <Button color={'primary'} variant={'contained'} onClick={handleSetFilter}>
            Применить
          </Button>
        </Stack>
      </Box>

    </Modal>
  )
}

export default FilterModal;
